import { render, staticRenderFns } from "./impressum.vue?vue&type=template&id=336e494a&scoped=true&"
import script from "./impressum.vue?vue&type=script&lang=js&"
export * from "./impressum.vue?vue&type=script&lang=js&"
import style0 from "./impressum.vue?vue&type=style&index=0&id=336e494a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336e494a",
  null
  
)

export default component.exports